import { Component } from '@angular/core';
import { ProfileComponent } from './profile/profile.component';
import { GroupsComponent } from './groups/groups.component';
import { RecentActivitiesComponent } from './recent-activities/recent-activities.component';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
    standalone: true,
    imports: [ProfileComponent, GroupsComponent, RecentActivitiesComponent, TranslateModule, FormsModule]
})
export class UserComponent {

}
